import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import plTranslation from './locales/pl/translation.json'
import { logger } from './utils/logger'

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'pl',
    fallbackLng: 'pl',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      pl: { translation: plTranslation },
    },
    partialBundledLanguages: true,
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    saveMissing: import.meta.env.DEV,
    missingKeyHandler: (lng, ns, key, fallbackValue) => {
      logger.addBreadcrumb({
        category: 'i18n',
        message: `Missing translation key: ${key}`,
        data: { lng, ns, fallbackValue },
        level: 'warning',
      })
    },
  })

export default i18n
